// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production  : false,
    hmr         : false,
    
    // URL_SICO    : 'http://localhost:8081/sico-web/rest/controllers/', //Local
    //URL_SICO    : 'http://172.16.2.197/sico-web/rest/controllers/', //Desarrollo
    // URL_SICO    : 'https://sicopruebas.coexito.com.co/sico-web/rest/controllers/', //Pruebas
    URL_SICO    : 'https://sico.coexito.com.co:9093/sico-web/rest/controllers/',//Produccion
    //URL_SICO    : 'http://sico.coexito.com.co:8080/sico-web/rest/controllers/', //NUBE
    //URL_SICO     : 'http://172.16.42.39/sico-web/rest/controllers/', //WMS 
    URL_PROMOCIONES    :    'https://promocionsico.coexito.com.co/sico-promociones/',
    // URL_PROMOCIONES     :'http://localhost:9091/',
    // URL_PROMOCIONES        :'http://localhost:8081/sico-web/rest/controllers/',
    // URL_AUTORIZADOR    : 'http://localhost:9090/autorizador/api/', //Local
    //URL_AUTORIZADOR    : 'http://172.16.2.197:9090/autorizador/api/', //Desarrollo
    // URL_AUTORIZADOR    : 'https://pruebasautorizaciones.coexito.com.co/autorizador/api/', //Pruebas
    URL_AUTORIZADOR    : 'https://autorizaciones.coexito.com.co:9092/autorizador/api/', //Produccion
    //URL_AUTORIZADOR    :  'http://172.16.2.39:9092/autorizador/api/', //NUBE
    //URL_AUTORIZADOR    :  'http://172.16.42.39:9092/autorizador/api/', //WMS

    OPCIONES_MENU: {
        TOMAR_PEDIDO: '/XHTML/pedidoPanel.xhtml?faces-redirect=true',
        CAPTURAR_RECAUDO: '/XHTML/recaudos/recaudos.xhtml?faces-redirect=true',
        SOLICITUD_ROTACION: '/XHTML/rotaciones.xhtml?faces-redirect=true',
        SOLICITUD_GARANTIAS: '/XHTML/garantias.xhtml?faces-redirect=true',
        SOLICITUD_LOGISTICA_REVERSIVA: '/XHTML/logisticaReversiva.xhtml?faces-redirect=true',
        CANCELAR_RECIBO: '/XHTML/cancelarRecibo.xhtml?faces-redirect=true',
        SOLICITUD_NOTA_CREDITO: 'SOLICITUD_NOTA_CREDITO'
    },

};